import { render, staticRenderFns } from "./navMain.vue?vue&type=template&id=52649d22&scoped=true"
import script from "./navMain.vue?vue&type=script&lang=js"
export * from "./navMain.vue?vue&type=script&lang=js"
import style0 from "./navMain.vue?vue&type=style&index=0&id=52649d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52649d22",
  null
  
)

export default component.exports